import { FC } from 'react';
import Description from '../../../components/Description';
import { QuestSchema } from '../../../../../types/quests';
import {
    Container,
    MarkdownContainer,
    DescriptionText,
    Timestamp
} from './styled';

interface Props {
    quest: QuestSchema;
}

const StatusSummarySection: FC<Props> = ({ quest }) => {
    return (
        <Container>
            <Description
                label="Status Summary"
                description={
                    <MarkdownContainer>
                        <DescriptionText>
                            {quest.statusSummary?.text}
                        </DescriptionText>
                        {quest.statusSummary?.timestamp && (
                            <Timestamp>
                                {`Updated: ${new Date(
                                    quest.statusSummary.timestamp
                                ).toLocaleString()}`}
                            </Timestamp>
                        )}
                    </MarkdownContainer>
                }
            />
        </Container>
    );
};

export default StatusSummarySection;
